import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbRoleApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'db-role';
    }

    /**
     * 获取全部数据
     */
    public async getListAll() {
        return await this.send({}, 'getListAll', Methods.GET);
    }

    /**
     * 获取角色的权限列表
     */
     public async getOpeList() {
        return await this.send({}, 'getOpeList', Methods.GET);
    }

    /**
     * 保存角色的权限
     * @param datas 
     * @returns 
     */
    public async saveUserOpe(datas) {
        return await this.send(datas, 'saveUserOpe', Methods.POST);
    }


}